/* src/views/OpeningHoursView.js */
import { ref, reactive, onMounted } from 'vue'
import { CalendarDays, CalendarX, Plus, Edit, Trash2, X, AlertCircle } from 'lucide-vue-next'
import { OpeningHoursService } from '@/services/OpeningHoursService'
import Swal from 'sweetalert2'

export default {
  name: 'OpeningHoursView',
  components: {
    CalendarDays, CalendarX, Plus, Edit, Trash2, X, AlertCircle
  },
  setup() {

    const activeTab = ref('weekly')
    const weeklyDays = ref([])
    const closures = ref([])
    const isWeeklyDrawerOpen = ref(false)
    const editDay = ref(null)
    const dayError = ref('')

    const isClosureDrawerOpen = ref(false)
    const isEditingClosure = ref(false)
    const customClosureError = ref('')
    const closureForm = reactive({
      id: null,
      occasione: '',
      data: '',
      isFullDay: true,
      start: '09:00',
      end: '18:00'
    })

    const fetchWeeklyDays = async () => {

      try {

        weeklyDays.value = await OpeningHoursService.getAllWeekly()
      } 
      catch (error) {
      
        console.error("Errore vista nel caricamento settimanali:", error)
      }
    }

    const fetchClosures = async () => {
      
      try {
        
        closures.value = await OpeningHoursService.getAllClosures()
      } 
      catch (error) {
      
        console.error("Errore vista nel caricamento chiusure:", error)
      }
    }

    const openWeeklyDrawer = (day) => {
      
      editDay.value = JSON.parse(JSON.stringify(day))
      dayError.value = ''
      isWeeklyDrawerOpen.value = true
    }

    const closeWeeklyDrawer = () => {
      
      isWeeklyDrawerOpen.value = false
      setTimeout(() => { editDay.value = null }, 300)
    }

    const addSlot = () => {
    
      if (editDay.value) {
    
        editDay.value.slots.push({ 
          id: null, 
          start: '09:00', 
          end: '18:00' 
        })
      }
    }

    const removeSlot = (index) => {
      
      if (editDay.value) {
      
        editDay.value.slots.splice(index, 1)
      }
    }

    const saveWeeklyDay = async () => {
     
      const payload = [{
        day_index: editDay.value.dayIndex,
        slots: editDay.value.slots.map(s => ({
          start: s.start,
          end: s.end
        }))
      }]
      
      try {
        
        await OpeningHoursService.updateWeekly(payload)
        await fetchWeeklyDays()
        closeWeeklyDrawer()
      } 
      catch (error) {
      
        dayError.value = "Errore durante il salvataggio."
      }
    }

    const formatSlots = (slots, isOpen) => {
      
      if (!isOpen || !slots || slots.length === 0) {

        return 'Chiuso'
      }
      return slots.map(s => `${s.start} - ${s.end}`).join(', ')
    }

    const openClosureCreate = () => {

      isEditingClosure.value = false
      closureForm.id = null
      closureForm.occasione = ''
      closureForm.data = ''
      closureForm.isFullDay = true
      closureForm.start = '09:00'
      closureForm.end = '18:00'
      customClosureError.value = ''
      isClosureDrawerOpen.value = true
    }

    const openClosureEdit = (c) => {

      isEditingClosure.value = true
      closureForm.id = c.id
      closureForm.occasione = c.name;
      closureForm.data = c.date;     
      closureForm.isFullDay = c.all_day
      closureForm.start = c.start_time || '09:00'
      closureForm.end = c.end_time || '18:00'
      customClosureError.value = ''
      isClosureDrawerOpen.value = true
    }

    const closeClosureDrawer = () => {

      isClosureDrawerOpen.value = false
    }

    const saveClosure = async () => {

      customClosureError.value = ''

      if (!closureForm.isFullDay && closureForm.start >= closureForm.end) {

        customClosureError.value = "L'orario di fine deve essere successivo a quello di inizio."
        return
      }

      try {

        if (closureForm.id !== null) {

          await OpeningHoursService.updateClosure(closureForm.id, closureForm)
        } 
        else {
        
          await OpeningHoursService.createClosure(closureForm)
        }
        await fetchClosures()
        closeClosureDrawer()
      } 
      catch (error) {
      
        customClosureError.value = "Errore durante il salvataggio."
      }
    }

    const deleteClosure = async (id) => {
      
      if (confirm('Sei sicuro di voler eliminare questa chiusura?')) {
      
        try {
      
          await OpeningHoursService.deleteClosure(id)
          await fetchClosures()
        } 
        catch (error) {
        
          Swal.fire({
            title: 'Errore',
            text: "Errore durante l'eliminazione.",
            icon: 'error',
            confirmButtonText: 'Chiudi'
          })
        }
      }
    }

    const formatDate = (dateStr) => {
      
      if (!dateStr) return '-'
      
      const [year, month, day] = dateStr.split('-')
      return `${day}/${month}/${year}`
    }

    onMounted(() => {
      
      fetchWeeklyDays()
      fetchClosures()
    })

    return {
      activeTab,
      weeklyDays,
      closures,
      isWeeklyDrawerOpen,
      editDay,
      dayError,
      isClosureDrawerOpen,
      isEditingClosure,
      customClosureError,
      closureForm,
      openWeeklyDrawer,
      closeWeeklyDrawer,
      addSlot,
      removeSlot,
      saveWeeklyDay,
      formatSlots,
      openClosureCreate,
      openClosureEdit,
      closeClosureDrawer,
      saveClosure,
      deleteClosure,
      formatDate
    }
  }
}